import _extends from "@babel/runtime/helpers/esm/extends";
var _g;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgEasi = function SvgEasi(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.8 14.7",
    style: {
      enableBackground: 'new 0 0 17.8 14.7'
    },
    xmlSpace: "preserve"
  }, props, {
    children: _g || (_g = /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        className: "easi_svg__st0",
        d: "M14 12.6 7.3 5.9c-.2-.2-.2-.3-.1-.6C8.1 3.1 6.7.6 4.3.4 2.8.2 1.6.8.8 2.1c-.7 1.3-.6 2.9.3 4 1 1.2 2.2 1.7 3.7 1.2.8-.2 1.2 0 1.6.5.2.3.5.5.8.8.1.1.3.2.4.4-.1 0-.1 0-.2.1 0 0-.1.1-.2.1l-3.4 3.4c-.4.4-.4.9 0 1.4.5.5 1 .5 1.5 0l3.3-3.3c.1-.1.1-.1.1-.2 0 0 0-.1.1-.1l.2.2.2.2 1.1 1.1 2.2 2.2c.5.5 1 .5 1.5 0 .5-.6.5-1.1 0-1.5z"
      }), /*#__PURE__*/_jsx("path", {
        className: "easi_svg__st0",
        d: "M17.3 3.5c-.2-.2-.5-.2-.8.1l-1.8 1.8-.8.8-.2.2c-.1.1-.2.2-.4.3-.2.2-.5.2-.7 0-.2-.2-.2-.5-.1-.7l.2-.2.1-.1 1-1 1.9-1.9c.3-.3.4-.6.1-.8-.2-.2-.5-.2-.8.1-.3.3-.6.6-1 .9l-.5.5-.4.4c-.4.4-.8.8-1.2 1.1-.1.1-.4.2-.6.2-.1 0-.3-.3-.3-.4 0-.2.1-.4.3-.5l2.1-2.1c.3-.2.6-.5.9-.8.3-.3.3-.6.1-.8-.2-.2-.5-.2-.8.1-.6.6-1.1 1.2-1.7 1.8-.5.5-1 1-1.5 1.6-.9.7-1 1.6-.5 2.6.4 1 1.2 1.5 2.2 1.5.9 0 1.5-.3 2-.8l.9-.9 2.2-2.2c.3-.3.3-.6.1-.8z"
      })]
    }))
  }));
};
export default SvgEasi;